module.exports = __webpack_public_path__ + "img/ev.6eb9991a.jpeg";